import { IPublicEnumDragObjectType } from '@alilc/lowcode-types';
import { isObject } from '../is-object';
export function isDragNodeDataObject(obj) {
  if (!isObject(obj)) {
    return false;
  }
  return obj.type === IPublicEnumDragObjectType.NodeData;
}